var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from "react";

var Span = function (_a) {
  var fontSize = _a.fontSize,
      children = _a.children,
      color = _a.color,
      lineThrough = _a.lineThrough,
      bold = _a.bold,
      styles = _a.styles,
      rest = __rest(_a, ["fontSize", "children", "color", "lineThrough", "bold", "styles"]);

  if (!children) return null;
  return React.createElement(React.Fragment, null, React.createElement("tspan", __assign({
    fontSize: fontSize,
    fill: color,
    style: __assign({
      verticalAlign: "middle",
      textDecoration: lineThrough ? "line-through" : "",
      fontWeight: bold ? "bold" : "normal"
    }, styles)
  }, rest), children));
};

export { Span };